import { useEffect } from "react";
import { scrollTop } from "../../components/Helper";

const TermsCondition = () => {
	useEffect(() => {
		scrollTop();
	}, []);
	
	return (
		<div className="col-lg-12">
			<div className="card overflow-hidden">
				<div className="card-header p-0 overflow-hidden">
					<div className="about-header">Terms and conditions</div>
				</div>
				<div className="card-body bg-white p-1">
					<div className="row">
						<div className="col-12">
							<h5 className="bg-light py-2">TERMS & CONDITIONS</h5>
							<ul className="about-text">
								<li>
									I am responsible for whatever the content I post at any section of this site, to respect that I do not post any content, rate or reply/review that may be
									considered, abusive, vulgar, offensive, obscene. Site Management is not responsible for any violations as per law.
								</li>
								<li>
									This site is for public for free use I always maintain courtesy, if I am a business person/organization, marketing person or any other soliciting person I pledge
									that I will not post repeated Ads, if I do any of this kind of activities, site management has the right to find the IP address or delete my ID and be barred for
									future postings from this IP address permanently.
								</li>
								<li>
									We respect Privacy according to US and Global laws, by agreeing to these terms I honor that I never post other's information like name, phone numbers, email
									addresses and physical addresses etc.
								</li>
								<li>
									I never do spam, no repeated ads in any of the sections with useless content, and I agree I am responsible to open any external links/URLs posted by other users
									and/or by Admin.{" "}
								</li>
								<li>I am agreeing that after I accept these terms & conditions I am solely responsible for whatever the content posted here or shared here in public chat.</li>
								<li>NRIS.COM Reserves all right to remove or delete any user permanently without any reason or prior notification.</li>
								<li>I am authorizing NRIS.com to track my IP address all the time for legal reasons.</li>
								<li>I always respect all other users of this site, and I expect the same from other users of this site.</li>
								<li>
									Furthermore, I agree that public chat is limited just to share the views of political issues, movies, sports and educational issues and I respect the same and I
									never use unparliamentary, unlawful, abusive, vulgar words or phrases at any time.
								</li>
								<li>We thank you in advance for your understanding and continued support.</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TermsCondition;
